import Modal from "../../../../../components/Modal";
import { Title, Text, SmallText, SuccessIcon, Continue, Cancel, Submit, Actions, Flex } from "./styles";
import { connect, useDispatch } from "react-redux";
import { hideModal } from "../../../../../store/actions/modal";
import { deletePost, resetDeletePost } from "../../../../../store/actions/post";
import { Post } from "../../../../../types/post";
import { Icon } from "../../../../../components/Icon/styles";
import checkIcon from "../../../../../assets/icons/check-bold.svg";
import { useCallback, useEffect, useState } from "react";

interface ComponentProps {
  post: Post;
  deletePostStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
}

const Component = ({ post, deletePostStates }: ComponentProps) => {
  const dispatch = useDispatch();
  const [countdown, setCountdown] = useState(5);
  const [articleDeleted, setArticleDeleted] = useState(false)

  const handleDeletePost = () => {
    dispatch(deletePost(post?.id));
  };

  const onModalClose = useCallback(() => {
    if (deletePostStates.success) {
      dispatch(hideModal())
      dispatch(resetDeletePost());
      window.location.href = `/dashboard/${post?.group?.group_type}/${post?.group?.id}/posts/`;
    }
  }, [post, deletePostStates.success]);

  useEffect(() => {
    if (deletePostStates.success) {
      setArticleDeleted(true)
    }
  }, [deletePostStates.success])

  useEffect(() => {
    if (articleDeleted) {
      if (countdown > 0) {
        const timer = setTimeout(() => {
          setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
      } else {
        dispatch(hideModal())
        dispatch(resetDeletePost());
        window.location.href = `/dashboard/${post?.group?.group_type}/${post?.group?.id}/posts/`;
      }
    }
  }, [articleDeleted, countdown]);

  return (
    <Modal
      name="modal-delete-post"
      width="320"
      showClose={false}
      onClose={() => onModalClose()}
    >
      {deletePostStates.success ? (
        <>
          <Flex>
            <SuccessIcon>
              <Icon icon={checkIcon} size="55px" color="#4CA154" />
            </SuccessIcon>
          </Flex>
          <div style={{ height: 28 }} />
          <Title>
            El artículo se elimino de tu biblioteca
          </Title>
          <div style={{ height: 8 }} />
          <Text>
            Tené en cuenta que esta acción es definitiva y no podrás volver a acceder a él.
          </Text>
          <div style={{ height: 28 }} />
          <Actions style={{ justifyContent: 'center' }}>
            <Continue
              onClick={() => {
                dispatch(hideModal());
                dispatch(resetDeletePost());
              }}
              href={`/dashboard/${post?.group?.group_type}/${post?.group?.id}/posts/`}
              options={{
                type: 'filled',
                size: 'md',
                skin: 'purple'
              }}
            >
              Volver a la biblioteca
            </Continue>
          </Actions>
          <div style={{ height: 8 }} />
          <SmallText>Toca "Volver a la biblioteca" o aguarda ({countdown} seg.)<br />y seras redirigido </SmallText>
        </>
      ) : (
        <>
          <Title>Vas a eliminar un artículo <br /> de tu biblioteca</Title>
          <div style={{ height: 8 }} />
          <Text>
            Estás por eliminar el artículo <br />
            <strong>“{post?.title}”</strong>. <br />

          </Text>
          <div style={{ height: 8 }} />
          <Text>
            Una vez eliminado no podrás recuperarlo y quienes tenían acceso al el ya
            no podrán verlo.
          </Text>
          <div style={{ height: 28 }} />
          <Actions>
            <Submit
              form=""
              isSubmmiting={deletePostStates.loading}
              options={{
                type: "filled",
                skin: "purple",
                size: "md",
              }}
              onClick={() => handleDeletePost()}
            >
              Eliminar articulo
            </Submit>

            <Cancel
              disabled={deletePostStates.loading}
              options={{
                type: "outline",
                skin: "black",
                size: "md",
              }}
              onClick={() => dispatch(hideModal())}
            >
              Cancelar
            </Cancel>
          </Actions>
        </>
      )}
    </Modal>
  );
};

const state = ({ postStore }) => {
  const { data: post } = postStore.post;
  const { states: deletePostStates } = postStore.deletePost;
  return {
    post,
    deletePostStates,
  };
};

export default connect(state)(Component);
